import {Injectable} from '@angular/core';

@Injectable()
export class PermissionConstant {
  // General
  static ALL = 'ALL';
  // Sessions
  static ADD_SESSION = 'SESSIONS_ADD_SESSION';
  static LIST_SESSION = 'SESSIONS_LIST_SESSION';
  static RE_REGISTER_SESSION = 'SESSIONS_RE_REGISTER_SESSION';
  static LIST_RE_REGISTERED_SESSION = 'SESSIONS_LIST_RE_REGISTERED_SESSION';

  // Modules
  static PROGRAMS = 'MODULES_PROGRAMS';
  static COURSES = 'MODULES_COURSES';
  static BRANCHES = 'MODULES_BRANCHES';
  static MAPPINGS = 'MODULES_MAPPINGS';
  static SUBJECTS = 'MODULES_SUBJECTS';

  // Centers
  static ADD_CENTER = 'CENTERS_ADD_CENTER';
  static LIST_CENTER = 'CENTERS_LIST_CENTER';
  static SHARE_PERCENTAGE = 'CENTERS_SHARE_PERCENTAGE';
  static ADMISSION_REPORT = 'CENTERS_ADMISSION_REPORT';
  static IA_AW_MARKS = 'CENTERS_IA_AW_MARKS';
  static CENTER_BRANCHES = 'CENTERS_LIST_CENTER_BRANCHES';

  // Students
  static DIRECT_STUDENTS = 'STUDENTS_DIRECT_STUDENTS';
  static CENTER_STUDENTS = 'STUDENTS_CENTER_STUDENTS';
  static VERIFY_DIRECT_STUDENTS = 'STUDENTS_VERIFY_DIRECT_STUDENTS';
  static VERIFY_CENTER_STUDENTS = 'STUDENTS_VERIFY_CENTER_STUDENTS';
  static ASSIGN_SID = 'STUDENTS_ASSIGN_SID';
  static PUSH_STUDENT_DATA = 'STUDENTS_PUSH_STUDENT_DATA';
  static ASSIGN_ENROLLMENT = 'STUDENTS_ASSIGN_ENROLLMENT';
  static FINAL_VERIFICATION = 'STUDENTS_FINAL_VERIFICATION';
  static ASSIGN_ROLL_NO = 'STUDENTS_ASSIGN_ROLL_NO';
  static RE_REGISTERED_STUDENTS = 'STUDENTS_RE_REGISTERED_STUDENTS';
  static TRANSFER_REQUESTS = 'STUDENTS_TRANSFER_REQUESTS';
  static ALL_STUDENTS = 'STUDENTS_ALL_STUDENTS';

  // Accounts
  static CENTERS_ADD_MONEY = 'ACCOUNTS_CENTERS_ADD_MONEY';
  static CENTERS_TRANSACTIONS = 'ACCOUNTS_CENTERS_TRANSACTIONS';
  static CENTERS_RECEIPTS = 'ACCOUNTS_CENTERS_RECEIPTS';

  // Support
  static ADMISSION_TICKETS = 'SUPPORT_ADMISSION_TICKETS';
  static RE_REGISTRATION_TICKETS = 'SUPPORT_RE_REGISTRATION_TICKETS';
  static EXAMINATION_TICKETS = 'SUPPORT_EXAMINATION_TICKETS';
  static MARKSHEET_TICKETS = 'SUPPORT_MARKSHEET_TICKETS';
  static TRANSCRIPT_TICKETS = 'SUPPORT_TRANSCRIPT_TICKETS';
  static REVALUATION_TICKETS = 'SUPPORT_REVALUATION_TICKETS';
  static MIGRATION_TICKETS = 'SUPPORT_MIGRATION_TICKETS';
  static ORIGINAL_DEGREE_TICKETS = 'SUPPORT_ORIGINAL_DEGREE_TICKETS';
  static E_LEARNING_TICKETS = 'SUPPORT_E_LEARNING_TICKETS';
  static OTHER_TICKETS = 'SUPPORT_OTHER_TICKETS';

  // Issues
  static MARKSHEET_ISSUES = 'ISSUES_MARKSHEET_ISSUES';
  static TRANSCRIPT_ISSUES = 'ISSUES_TRANSCRIPT_ISSUES';
  static REVALUATION_ISSUES = 'ISSUES_REVALUATION_ISSUES';
  static MIGRATION_ISSUES = 'ISSUES_MIGRATION_ISSUES';
  static ORIGINAL_DEGREE_ISSUES = 'ISSUES_ORIGINAL_DEGREE_ISSUES';
  static PROVISIONAL_ISSUES = 'ISSUES_PROVISIONAL_ISSUES';
  static OTHER_ISSUES = 'ISSUES_OTHER_TICKETS';


  // Access
  static ROLES = 'ACCESS_ROLES';
  static PERMISSIONS = 'ACCESS_PERMISSIONS';

  // Departments
  static ADD_DEPARTMENT = 'DEPARTMENTS_ADD_DEPARTMENT';
  static LIST_DEPARTMENT = 'DEPARTMENTS_LIST_DEPARTMENT';
  static ADD_EMPLOYEE = 'DEPARTMENTS_ADD_EMPLOYEE';
  static LIST_EMPLOYEE = 'DEPARTMENTS_LIST_EMPLOYEE';
  static ADD_VIDEO_LECTURE = 'DEPARTMENTS_ADD_VIDEO_LECTURE';
  static LIST_VIDEO_LECTURE = 'DEPARTMENTS_LIST_VIDEO_LECTURE';
  static ADD_SLM = 'DEPARTMENTS_ADD_SLM';
  static LIST_SLM = 'DEPARTMENTS_LIST_SLM';
  static ADD_ASSIGNMENT = 'DEPARTMENTS_ADD_ASSIGNMENT';
  static LIST_ASSIGNMENT = 'DEPARTMENTS_LIST_ASSIGNMENT';

  // Exams
  static EXAM_SESSION = 'EXAMS_EXAM_SESSIONS';
  static EXAMS_SCHEDULE_EXAM = 'EXAMS_SCHEDULE_EXAM';
  static EXAMS_MARKED_BACK_EXAMS = 'EXAMS_MARKED_BACK_EXAMS';
}
